// header sticky
$(window).scroll(function () {
  if ($(window).scrollTop() > 40) {
    $('.fixed-announce').addClass('is-sticky');
    $('body').addClass('header_fixed');

  }
  else {
    $('.fixed-announce').removeClass('is-sticky');
    $('body').removeClass('header_fixed');
  }
});
// Document Ready Start
$(document).ready(function ($) {
  // add active link to child if grandchild is current
  $('.ctm_header-menu-grandchild').each(function () {
    if ($(this).hasClass('mega-menu__link--active')) {
      // console.log("has Class");
      $(this).parent('ul.list-unstyled').prev('.ctm_header-menu-child').addClass('mega-menu__link--active');
    } else {
      // console.log("Not has Class");
    }
  });

  /* home search filter js */
  setInterval(function () {

    $(".healthy-form-hm #gf-form .gf-form-inner .gf-form-input-wrapper").each(function () {
      // Get the text of each li element
      var labelText = $(this).find('label,.spf-btn').text();

      // Remove spaces and convert to lowercase
      labelText = labelText.replace(/ /g, '').toLowerCase();

      // Append the modified text to the parent element with id "parent"
      $(this).addClass(labelText);
    });
  }, 3000);

  // sitemap loadmore
  $(function () {
    $(".ctm_sitemap_pages_list").slice(0, 20).show();
    $("body").on('click touchstart', '.load_more_pages', function (e) {
      e.preventDefault();
      $(".ctm_sitemap_pages_list:hidden").slideDown();
      $(".ctm_sitemap_pages_more").css('display', 'none'); // Assuming you 
    });
  });
  $(function () {
    $(".ctm_sitemap_collection_list").slice(0, 20).show();
    $("body").on('click touchstart', '.load_more_collection', function (e) {
      e.preventDefault();
      $(".ctm_sitemap_collection_list:hidden").slideDown();
      $(".ctm_sitemap_collection_more").css('display', 'none'); // Assuming you  
    });
  });
  $(function () {
    $(".ctm_sitemap_brands_list").slice(0, 20).show();
    $("body").on('click touchstart', '.load_more_brands', function (e) {
      e.preventDefault();
      $(".ctm_sitemap_brands_list:hidden").slideDown();
      $(".ctm_sitemap_braands_more").css('display', 'none'); // Assuming you 
    });
  });
  // Main Banner slider 
  $('.main-banner .banner_listing').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,

  });
  // Categories Slider
  $('.our-categories .cat_listing').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1460,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false
        }
      }
    ]
  });
  // Brand Image Slider
  $('.brand-img-slider .image_listing').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1460,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {

          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {

          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 430,
        settings: {

          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  /* Prodcut detail */
  $('.accordion-panel .accordion_item:first-child').addClass('active');
  $('.accordion-panel .accordion_item:not(:first-child) .accordion_content').slideUp();
  $('.accordion_title').click(function () {
    var content = $(this).next('.accordion_content');
    $(this).parent().toggleClass('active');
    content.slideToggle();
  });
  $('.product-description ul.links li:first-child a').addClass('active');
  $('.product-description ul.links a').click(function (e) {
    e.preventDefault();
    var targetId = $(this).attr('href');
    var headerheight = $('.fixed-announce').outerHeight();
    var newheaderHeight = headerheight;
    $('html, body').animate({
      scrollTop: $(targetId).offset().top - newheaderHeight
    }, 1000);
    // Add 'active' class to clicked link and remove it from others
    $('.product-description ul.links a').removeClass('active');
    $(this).addClass('active');
    //$('.accordion-panel .accordion_content').slideUp();
    $(targetId).closest('.accordion_item').find('.accordion_content').slideDown().parent('.accordion_item').addClass('active');

  });
  // Select all span elements within list items
  var spans = $('.product-description .accordion-panel .accordion_content .product_mata_info ul li');
  // Loop through each span element
  spans.each(function () {
    // Get the text content of the span
    var text = $(this).text();

    // Extract the first character
    var firstCharacter = text.charAt(0);

    // Output the first character (you can do something else with it)
    $(this).prepend('<span>' + firstCharacter + '</span>')
  });
  $('.qa-content .description li a,.shoe_glossary .short_description .description > p > a').click(function (e) {
    e.preventDefault();
    var headerheight = $('.fixed-announce').outerHeight();
    var targetId = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(targetId).offset().top - headerheight
    }, 1000);
  });

  $('form h2.form__message + ul li a').click(function () {
    // e.preventDefault();
    var headerheight = $('.fixed-announce').outerHeight();
    var targetId = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(targetId).offset().top - headerheight
    }, 1000);
  });

  $('.submit-address button[type="reset"]').click(function () {
    $("html").animate({ scrollTop: 0 }, "slow");
  });
  /* Recently viewed product slider */
  $('.recently-viewed-wrapper .recently-viewed-grid').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {

          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  var relatedproduct = setInterval(function () {
    // Check if the element with the class "product-recommendations--loaded" exists
    if ($('.product-recommendations--loaded').length > 0) {
      // Clear the interval if the element is found
      clearInterval(relatedproduct);

      // Apply slick to the element after clearing the interval
      $('.related-products .product-grid').slick({
        dots: false,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 575,
            settings: {

              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }, 500);

  /* Product Detail popup */

  $('.product-description .accordion_content .product_mata_info ul span.metafield-multi_line_text_field').contents().unwrap();
  $(".product-description .product_mata_info li").each(function (index) {
    var liTextContent = $(this).contents().filter(function () {
      return this.nodeType === Node.TEXT_NODE;
    }).text();
    $(this).contents().filter(function () {
      return this.nodeType === Node.TEXT_NODE;
    }).remove();
    $(this).append('<strong class="ImgModal" data-group="">' + liTextContent + '</strong>');

  });

  $(".product-description .product_mata_info.features li").each(function (index) {
    var features = $(this).find(".ImgModal");
    features.attr("data-group", "feature");

  });

  $(".product-description .product_mata_info.condition li").each(function (index) {
    var features = $(this).find(".ImgModal");
    features.attr("data-group", "condition");

  });
  $(".ImgModal").on('click', function () {
    cat = $(this).data('group');
    descriptName = $(this).text().trim().toLowerCase().replaceAll(" ", "");
    descriptName = descriptName.replaceAll("-", "");
    descriptName = descriptName.replaceAll("/", "");
    descriptName = descriptName.replaceAll("(", "");
    descriptName = descriptName.replaceAll(")", "");
    descriptName = descriptName.replaceAll("'", "");
    descriptName = descriptName.replaceAll(",", "");
    var modalimg = $('#image-modal .img_content img');
    //modalimg.style.width = "100%";
    var imagemodal = $("#image-modal");
    imagemodal.attr("open", "open");
    var urlImage = $("#image-modal .img_content .img_url").val().split('?')[0];
    var tempUrl = urlImage + 'n' + cat + '_desc_' + descriptName + '.png';
    modalimg.attr('src', tempUrl);
  });

  // Announce slider
  $('.announce_slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
         breakpoint: 99999,
        settings:'unslick'
      },
      {
        breakpoint: 1285,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  // footer accordion
  if ($(window).width() < 1025) {
    $(".col_menu_all > .ft_heading").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
          .siblings(".col_menu_all ul")
          .slideUp(200);
        $(".col_menu_all > .ft_heading")
          .removeClass("minus")
          .addClass("plus");
      } else {
        $(".col_menu_all > .ft_heading")
          .removeClass("minus")
          .addClass("plus");
        $(this).removeClass("plus").addClass("minus");
        $(".col_menu_all > .ft_heading").removeClass("active");
        $(this).addClass("active");
        $(".col_menu_all ul").slideUp(200);
        $(this)
          .siblings(".col_menu_all ul")
          .slideDown(200);
      }
    });
  }
  // footer form placeholder
  setInterval(function () {
    $("#email_address_1").attr("placeholder", "Your Email Address");
  }, 1000);
  // megamenu
  $('.header__inline-menu a').mouseenter(function () {
    var data = $(this).data('dropdown-rel');
    $('.desktop_mega_menu').css('display', 'none');
    $('.desktop_mega_menu[data-dropdown="' + data + '"]')
      .css('display', 'block');
  });

  $('.header__inline-menu a').mouseleave(function () {
    if ($('.mega-menu-section:hover').length == 0) {
      $('.desktop_mega_menu').css('display', 'none');
    }
  })
    .mouseleave();
  $('.mega-menu-section').mouseleave(function () {
    if ($('.mega-menu-section:hover').length == 0) {
      $('.desktop_mega_menu').css('display', 'none');
    }
  })
    .mouseleave();

  // add dropdown in megamenu
  var menuRels = $('.ctm_header_nav_menu ul li a').attr('data-dropdown-rel');
  var dropRels = $('.desktop_mega_menu').attr('data-dropdown');

  $('.ctm_header_nav_menu ul li a[data-dropdown-rel="' + dropRels + '"]').addClass('dropdown');

  // color swatches
  setTimeout(() => {
    $('.ctm_variant_div').each(function () {
      var lolabel = $(this).find('label').length;
      // console.log('Label Count',lolabel);
      if (lolabel < 1) {
        $(this).hide();
        $(this).remove();
        // console.log("lolabel removed");
      }
    });
  }, 3000);

  setTimeout(() => {
    $('.ctm_variant_div_span .ctm_variant_spans label.hidden').remove();
  }, 7000);
  $(document).on('change', '.ctm_variant_div input[type="radio"]', function (e) {
    var variant_img_src = $(e.currentTarget).attr('data-image');

    if (variant_img_src) {
      $(e.currentTarget).closest('.card-wrapper').find('.card__media img').attr('src', variant_img_src);
      $(e.currentTarget).closest('.card-wrapper').find('.card__media img').attr('srcset', variant_img_src);
    }
  });

  setTimeout(() => {
    // view more button
    $(".view_eye").on("click", function () {
      console.log('working');
      $(this).closest('.card-wrapper').find('.quick-add__submit.button').click();
    });
  }, 500);

  // add class to input from li
  $('li.ctm_recent_li').each(function () {
    var li = $(this);
    var classNames = li.attr('class').split(' '); // Get an array of class names
    var sanitizedClassNames = classNames.join(''); // Remove spaces between classes

    // Find all input elements and labels within the li
    var inputsAndLabels = li.find('input, label');

    // Iterate through each input and label
    inputsAndLabels.each(function () {
      var element = $(this);

      // Get the current element's tag name (input or label)
      var tagName = element.prop('tagName').toLowerCase();

      // Get the current element's "for" or "id" attribute
      var attributeName = (tagName === 'input') ? 'id' : 'for';

      // Append the class name to the attribute
      var attributeValue = element.attr(attributeName) + ' ' + sanitizedClassNames;

      // Set the modified attribute back to the element
      element.attr(attributeName, attributeValue.trim()); // Trim any extra spaces
    });
  });

  // hide element if more than 5 
  // if ($('.ctm_variant_spans').length > 5) {
  //   $('.ctm_variant_spans:nth-child(n+6)').hide();
  //   $('.ctm_variant_spans:nth-child(n+6)').parent().next().show();
  // }
  
// Function to handle the display of items
function handleVariantDisplay() {
    $('.grid__item').each(function () {
        // Get the repeated .ctm_variant_spans elements within the .ctm_variant_div_span of the current .grid__item
        const $ctmVariantSpans = $(this).find('.ctm_variant_div_span .ctm_variant_spans');
        const $viewMoreDiv = $(this).find('.view--more');

        if ($ctmVariantSpans.length > 5) {
            // Show only the first 5 items
            $ctmVariantSpans.slice(0, 5).show();
            $ctmVariantSpans.slice(5).hide();

            // Ensure .view--more is visible
            $viewMoreDiv.show();

            // Add click event to the view-more button
            $viewMoreDiv.on('click', function() {
                // Show all hidden items
                $ctmVariantSpans.slice(5).show();

                // Hide the .view--more button after showing all items
                $viewMoreDiv.hide();
            });
        } else {
            // Show all items if there are 5 or fewer
            $ctmVariantSpans.show();

            // Remove .view--more if items are 5 or fewer
            $viewMoreDiv.remove();
        }
    });
}

// Initially handle the variant display
handleVariantDisplay();

// Listen for clicks inside #FacetFiltersForm and re-run the variant display function
$('#FacetFiltersForm input, #FacetFiltersForm *').on('click', function(e) {
    e.stopPropagation(); // Prevent event bubbling if necessary

    // Start a setInterval to check for the presence of .ctm_variant_div_span
    const interval = setInterval(function() {
        // Check if .ctm_variant_div_span exists
        if ($('.ctm_variant_div_span').length > 0) {
            // Element found, run the handleVariantDisplay function
            handleVariantDisplay();

            // Clear the interval to stop checking after the element is found
            clearInterval(interval);
        }
    }, 2000); // Check every 100ms
});
  

  $('.accordion__content .alpha-index a').on('click', function (event) {
    event.preventDefault();
    $('.accordion__content .alpha-index a').removeClass('active');
    $(this).addClass('active');
    var targetId = $(this).attr('href');
    var targetElement = $(targetId);
    var headerheight = $('.fixed-announce').height();
    if (targetElement.length) {
      $('html, body').animate({
        scrollTop: targetElement.offset().top - headerheight
      }, 1000);
    }
  });
  $('.cust-collapsible.resource-center details').attr('open', true);
  $('.ctm_collapsibles__accordion details summary').each(function (index) {
    $(this).on('click', function () {
      // Set the target element
      var targetElement = $(this).parent('details');
      // Close other details elements
      var headerheight = $('.fixed-announce').height();
      if ($(this).parent('details').attr('open') !== undefined) {
        $(this).parent('details').attr('open', true);


      } else {
        $(this).parent('details').attr('open', false);
        $('html, body').animate({
          scrollTop: targetElement.offset().top - headerheight
        }, 1000);
      }

    });
  });



  $('.ctm_header_icons .search-modal__form .field input').focus(function () {
    // Add a class to the body tag
    //$('body').addClass('suggestion-open');
  });

  // When clicking outside the input field
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.ctm_header_icons .search-modal__form .field input').length) {
      // Remove the class from the body tag
      $('body').removeClass('suggestion-open');
    }
  });

  // Get the list items
  $('.product-description .accordion_content .product_mata_info ul').each(function (index) {
    var $listItems = $(this).children("li");

    // Sort the list items based on the first word
    $listItems.sort(function (a, b) {
      var textA = $(a).text().trim().split(' ')[0].toLowerCase();
      var textB = $(b).text().trim().split(' ')[0].toLowerCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    // Re-append the sorted list items to the list
    $(this).append($listItems);
  });

/* Header Mega Menu click event add class */  
$(".ctm_header_nav_menu ul details summary.ctm_header-menu").each(function () {
  $(this).click(function () {
      // Check if the clicked menu item has 'active' class
      if ($(this).hasClass('active')) {
          // Remove 'active' class from the clicked menu item
          $(this).removeClass('active');
          
          // Remove 'active' class from the body
          $('body').removeClass('hovered');
      } else {
          // Toggle 'active' class on the clicked menu item
          $(this).addClass('active');
          
          // Optionally, if you want to remove 'active' class from other menu items
          $(".ctm_header_nav_menu ul details summary.ctm_header-menu").not(this).removeClass('active');
          
          // Add 'active' class to the body
          $('body').addClass('hovered');
      }
  });
});
   
$(document).on('click', function (event) {
    // Check if the click is outside the specified element
    if (!$(event.target).closest('.ctm_header_nav_menu ul details.mega-menu').length && !$(event.target).closest('.close-megamenu').length) {
        // Remove class from body
        $('body').removeClass('hovered');
        $(".ctm_header_nav_menu ul details summary.ctm_header-menu").removeClass('active');
        $('.mega-menu').removeAttr('open');
    }
    
});

$('.close-megamenu').on('click', function () {
    // Remove class from body
    $('body').removeClass('hovered');
    $(".ctm_header_nav_menu ul details summary.ctm_header-menu").removeClass('active');
    $('.mega-menu').removeAttr('open');
});

/* End */  

  $('.product-form__input input[type=radio]').on('click', function () {
    // Get the selected color value
    var selectedColor = $(this).val();
    // Update the text of the selected-variant-color-label
    $(this).siblings('.form__label').find('span').text(selectedColor);
  });

  // Iterate over each set of elements with class "jdgm-rev__scale-range"
  setTimeout(() => {
    $('.jdgm-rev__scale-range').each(function () {
      // Find the elements with the class "jdgm--empty"
      var emptyElements = $(this).find('.jdgm-cf-bar.jdgm--filled');
      // Count the elements with the class "jdgm--empty"
      var emptyCount = emptyElements.length;
      // Add the same class to the first element with the class "jdgm--empty"
      emptyElements.last().addClass('last-empty');
    });
  }, 5000);



  // Iterate through labels and set data-label
  var updateLabelsInterval = setInterval(function () {
    $('.jdgm-cf__options[data-type="scale"] .jdgm-cf__option').each(function (index) {
      var labelElement = $(this).find("label.jdgm-cf-label.jdgm-cf-label-radio");
      var labelText = labelElement.text().trim();
      labelElement.attr('data-label', labelText);
    });
  }, 500);

  var checkRadioInputsInterval = setInterval(function () {
    checkRadioInputs();
  }, 500);

  function checkRadioInputs() {
    var labelTrueToSize = $("label[data-label='True To Size']");
    var labelTrueToWidth = $("label[data-label='True To Width']");
    var labelGreatSupport = $("label[data-label='Good Support']");

    // Check the corresponding radio inputs based on data-label values
    checkRadioInput(labelTrueToSize);
    checkRadioInput(labelTrueToWidth);
    checkRadioInput(labelGreatSupport);

    // Check a condition to stop intervals
    if (labelTrueToSize.length > 1 || labelTrueToWidth.length > 1 || labelGreatSupport.length > 1) {
      // Stop the intervals
      clearInterval(updateLabelsInterval);
      clearInterval(checkRadioInputsInterval);
    }
  }

  function checkRadioInput(labelElement) {
    // Check the corresponding radio input based on data-label value
    if (labelElement.length > 0) {
      var inputId = labelElement.attr('for');
      $('#' + inputId).prop('checked', true);
    }
  }

  /* PDP Pages You May Also like JS */

  // $('#you-may-also-like .mf-1').parents('.related-li').addClass('em-related-li');
  // $('#you-may-also-like .em-related-li').remove();

  // $('#you-may-also-like ul.grid.product-grid').each(function () {
  //     // Check if "product-grid" class exists in the children of this list item
  //     if ($(this).find('li.related-li').length === 0) {
  //       // If not found, add a class to the main parent (ul)
  //       $(this).parents('#you-may-also-like').addClass('no-rel-product-grid');
  //     }
  // });

  let interval1;
  function runAtIntervals() {
    // First action
    $('#you-may-also-like .mf-1').parents('.related-li').addClass('em-related-li');
    $('#you-may-also-like .em-related-li').remove();

    // Second action
    $('#you-may-also-like .grid.product-grid').each(function () {
      // Check if "product-grid" class exists in the children of this list item
      if ($(this).find('.related-li').length === 0) {
        // If not found, add a class to the main parent (ul)
        $(this).parents('#you-may-also-like').addClass('no-rel-product-grid');

        // Clear the interval when the condition is met
        clearInterval(interval1);
      }
    });
  }

  // Start the interval
  interval1 = setInterval(runAtIntervals, 500); 


  /** Remove tabindex core web vital */ 

 var intervalId = setInterval(function() {
  var elements = $('.grid__item.slick-slide').find('.jdgm-prev-badge__stars');
  elements.removeAttr('tabindex', 0);
    if (elements.length > 0) {
    clearInterval(intervalId);
  }

  var topslider = $('.announce_slider__flex[tabindex="0"]');
  topslider.attr('aria-hidden', 'false');
   topslider.find('a').attr('tabindex', 0);
    if (topslider.length > 0) {
    clearInterval(intervalId);
  } 
   
}, 500);

    // Get the src attribute of the image while thumbnail clicked
    $(".thumbnail-list li.thumbnail-list__item").each(function () {
        var $thumbnail = $(this).find('.thumbnail');
        $thumbnail.on('click', function () {
            // Get the data-image-src attribute value from the clicked thumbnail
            var newSrc = $thumbnail.find('img').attr('src');
            // Set the new src attribute for the main image
            $('.product__media-item.is-active img')
                .attr('src', newSrc)
                .attr('srcset', newSrc + ' 1946w'); // Change this part accordingly
        });
    });

  // Document Ready Closed
});

document.addEventListener('DOMContentLoaded', function () {
  var textContent = {};
  if ('content' in document.createElement('template')) {

    let iconButtons = document.querySelector('[data-content]') ? Array.from(document.querySelectorAll('[data-content]')) : [];
    if (iconButtons.length === 0) return; // Check if there are any iconButtons to iterate over

    iconButtons.forEach(item => {
      if (item.tagName.toLowerCase() === 'a') {
        let templateToUpdate = document.querySelector(item.dataset.content);
        let pageUrl = templateToUpdate.getAttribute('data-url');

        if (pageUrl) {
          fetch(`${pageUrl}`)
            .then(response => response.text())
            .then(text => {
              $($(`${item.dataset.content}`)[0].content.children[1]).find('p').html($(text).find('.page.content, .page_content'));
            });
        }
      }
    });

    iconButtons.forEach(item => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        let templateToUpdate = document.querySelector(item.dataset.content);
        let template = document.querySelector(item.dataset.content);
        let clone = document.importNode(template.content, true);
        let modal = document.getElementById('product-popup-modal__content-info');
        modal.appendChild(clone);
        let button = document.getElementById('ProductPopup-width-chart');
        button.click();
        console.log(modal);
      });
    });

    let closeBtn = document.getElementById('ModalClose-width-chart');
    closeBtn.addEventListener("click", function () {
      let modal = document.getElementById('product-popup-modal__content-info');
      modal.textContent = "";
    });

    let dialogCloseBtn = document.getElementById('PopupModal-width-chart');
    dialogCloseBtn.addEventListener("click", function () {
      let modal = document.getElementById('product-popup-modal__content-info');
      modal.textContent = "";

      var childElement = document.querySelector('.product-popup-modal__content');
      childElement.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
    // Select the details elements
    const detailsElements = document.querySelectorAll(".custom_facets facet-filters-form.facets.small-hide form details");

    // Add the 'open' attribute to each details element
    detailsElements.forEach(details => {
        details.setAttribute("open", "open");
    });
});

